module.exports = __webpack_public_path__ + "static/media/students and Stingray 20s.615a8446.JPG";